import { render, staticRenderFns } from "./ModalSearchProjects.vue?vue&type=template&id=529450c4&scoped=true&lang=pug&"
import script from "./ModalSearchProjects.vue?vue&type=script&lang=js&"
export * from "./ModalSearchProjects.vue?vue&type=script&lang=js&"
import style0 from "./ModalSearchProjects.vue?vue&type=style&index=0&id=529450c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529450c4",
  null
  
)

export default component.exports